const SKIN_TYPE_PARAM = 'skin_type';

class SkincareQuiz extends HTMLElement {
  constructor() {
    super();

    this.state = {
      skinType: '',
      skinProblem: '',
      collectionUrl: '',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.initializeFromUrl();
    this.dataset.quizReady = 'true';
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const skinTypeOption = event.target.closest('[data-quiz-skin-type-option]');
    if (skinTypeOption instanceof HTMLElement) {
      event.preventDefault();
      this.selectSkinType(skinTypeOption);
      return;
    }

    const skinProblemOption = event.target.closest('[data-quiz-skin-problem-option]');
    if (skinProblemOption instanceof HTMLElement) {
      this.selectSkinProblem(skinProblemOption);
      return;
    }

    const breadcrumb = event.target.closest('[data-quiz-breadcrumb="start"]');
    if (breadcrumb instanceof HTMLElement) {
      event.preventDefault();
      this.reset();
    }
  }

  selectSkinType(option) {
    this.state = {
      skinType: option.dataset.value || '',
      skinProblem: '',
      collectionUrl: '',
    };

    window.history.pushState({ ...this.state }, '', this.buildSkinTypeUrl(window.location.pathname));
    this.updateBreadcrumbs();
    this.updateProblemLinks();
    this.showStep('skin-problem');
  }

  selectSkinProblem(option) {
    this.state = {
      ...this.state,
      skinProblem: option.dataset.value || '',
      collectionUrl: this.findCollectionUrl(option.dataset.value || ''),
    };
  }

  reset() {
    this.state = {
      skinType: '',
      skinProblem: '',
      collectionUrl: '',
    };

    window.history.pushState({ ...this.state }, '', this.buildUrl(window.location.pathname));
    this.updateBreadcrumbs();
    this.showStep('skin-type');
  }

  initializeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const skinType = params.get(SKIN_TYPE_PARAM) || '';

    if (!skinType) {
      this.showStep('skin-type');
      return;
    }

    this.state = {
      skinType,
      skinProblem: '',
      collectionUrl: '',
    };

    this.updateBreadcrumbs();
    this.updateProblemLinks();
    this.showStep('skin-problem');
  }

  showStep(stepName) {
    this.querySelectorAll('[data-quiz-step]').forEach((step) => {
      if (!(step instanceof HTMLElement)) return;
      step.hidden = step.dataset.quizStep !== stepName;
    });
  }

  updateBreadcrumbs() {
    const skinTypeCrumb = this.querySelector('[data-quiz-skin-type-crumb]');
    const skinTypeLink = this.querySelector('[data-quiz-selected-skin-type]');

    if (skinTypeCrumb instanceof HTMLElement) {
      skinTypeCrumb.hidden = !this.state.skinType;
    }

    if (skinTypeLink instanceof HTMLAnchorElement) {
      skinTypeLink.textContent = this.state.skinType;
      skinTypeLink.href = this.buildSkinTypeUrl(window.location.pathname);
    }
  }

  updateProblemLinks() {
    this.querySelectorAll('[data-quiz-skin-problem-option]').forEach((option) => {
      if (!(option instanceof HTMLElement)) return;

      const link = option.querySelector('a');
      const collectionUrl = this.findCollectionUrl(option.dataset.value || '');

      option.hidden = !collectionUrl;

      if (link instanceof HTMLAnchorElement) {
        link.href = collectionUrl ? this.buildUrl(collectionUrl) : this.buildUrl(window.location.pathname);
      }
    });
  }

  getCollectionMap() {
    const source = this.querySelector('[data-quiz-collections]');
    if (!(source instanceof HTMLScriptElement) || !source.textContent) return [];

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.error('Failed to parse skincare quiz collections:', error);
      return [];
    }
  }

  findCollectionUrl(skinProblem) {
    const collection = this.getCollectionMap().find((item) => {
      return item.skinType === this.state.skinType && item.skinProblem === skinProblem;
    });

    return collection?.url || '';
  }

  buildUrl(path) {
    const url = new URL(path, window.location.origin);
    return `${url.pathname}${url.search}`;
  }

  buildSkinTypeUrl(path) {
    const url = new URL(this.buildUrl(path), window.location.origin);
    url.searchParams.set(SKIN_TYPE_PARAM, this.state.skinType);
    return `${url.pathname}${url.search}`;
  }
}

if (!customElements.get('skincare-quiz')) {
  customElements.define('skincare-quiz', SkincareQuiz);
}
